import {
  createBrowserRouter,
  RouterProvider,
  Route,
  createRoutesFromElements,
} from 'react-router-dom';
import DeleteRequest from './Pages/DeleteRequest';
import MoveRequestsForm from './components/MoveRequestsForm';
import RequestAssetDataForm from './components/RequestDataForm';
import SearchAssets from './Pages/SearchAssets';
import AssetsRequest from './Pages/AssetsRequest';
import { ConfigProvider } from 'antd';

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route>
      <Route path='/' element={<RequestAssetDataForm />} />
      <Route path='/delete-requests' exact element={<DeleteRequest />} />
      <Route path='/edit-requests' exact element={<MoveRequestsForm />} />
      <Route path='/search-assets' exact element={<SearchAssets />} />
      <Route path='/request-assets' exact element={<AssetsRequest />} />
    </Route>
  )
);

function App() {
  return (
    <ConfigProvider direction='rtl'>
      <RouterProvider router={router} />
    </ConfigProvider>
  );
}

export default App;
